// extracted by mini-css-extract-plugin
export default {"container":"PublicLayoutProducts_container__R+1E1"};